module.exports = __webpack_public_path__ + "img/detail.90034506.png";